import { buildCoverUrl, CONTENT_SIZE } from '@/utils/image'

/**
 * 内容图（帖子配图、评论配图等）走 CDN 缩略图的复用逻辑。
 *
 * 为什么不直接用 <smart-img>：这些位置需要 el-image 的全屏预览
 * （preview-src-list + image-viewer），换成裸 img 就得自己实现预览器。
 * 所以保留 el-image，只把「地址换缩略图 + 失败退回原图」抽到这里。
 *
 * 三条硬性约束：
 *
 * 1. 列表里显示的是缩略图，**预览必须用原图**。
 *    列表里一张配图只占 138px，却在下载 268KB 的 1079x1920 原图，换成缩略图后
 *    只有几十 KB。但点开全屏预览时要看清细节，
 *    所以 preview-src-list 一律传原始数组，不要传缩略图。
 *
 * 2. 必须有失败降级。数据万象的现场处理在 CDN 缓存未命中时会失败
 *    （详见 @/utils/image 顶部注释），所以 el-image 上要挂
 *    @error="onContentThumbError(原图地址)"，失败后自动改用原图重试。
 *
 * 3. 用这个 mixin 的格子都是 fit="cover" 的正方形格子，缩略图走 buildCoverUrl（短边优先 + 居中裁方）。
 *    原来用的是「限最长边」，长图的宽度被压成细条（572x1920 → 107x360）再放大，看起来很糊。
 *    如果以后有地方要按原图比例完整显示（contain），或者格子不是正方形，不要用这个 mixin。
 *
 * 用法：
 *   <el-image
 *     :src="contentThumb(img)"
 *     :preview-src-list="originalList"
 *     @error="onContentThumbError(img)" />
 */
export default {
  data () {
    return {
      // 缩略图加载失败的原图地址集合，这些改用原图渲染
      brokenThumbUrls: []
    }
  },

  methods: {
    /**
     * 取要渲染的地址：默认缩略图，已知失败过的退回原图。
     * @param {string} url 原图地址
     * @param {number} [size=CONTENT_SIZE] 格子边长（物理像素，会向上对齐到固定档位）
     */
    contentThumb (url, size = CONTENT_SIZE) {
      if (!url) return ''
      if (this.brokenThumbUrls.indexOf(url) !== -1) return url
      return buildCoverUrl(url, size)
    },

    /** 缩略图挂了就记下来，下一次渲染改用原图 */
    onContentThumbError (url) {
      if (url && this.brokenThumbUrls.indexOf(url) === -1) {
        this.brokenThumbUrls.push(url)
      }
    }
  }
}
